import styled, { keyframes } from 'styled-components';

export type Props = {
	height: number | string;
	width?: number | string;
	cornerRadius?: number;
	opacity?: number;
	className?: string;
};

interface InternalProps {
	$widthInternal?: number | string;
	$heightInternal: number | string;
	$opacityInternal: number;
	$cornerRadius: number | string;
}

const animation = keyframes`
	0% {
		background-position: top right;
	}
	100% {
		background-position: top left;
	}
`;

const StyledShimmer = styled.div<InternalProps>`
	display: flex;
	width: ${({ $widthInternal }) => (typeof $widthInternal === 'string' ? $widthInternal : `${$widthInternal}px`)};
	height: ${({ $heightInternal }) => (typeof $heightInternal === 'string' ? $heightInternal : `${$heightInternal}px`)};
	opacity: ${({ $opacityInternal }) => $opacityInternal};

	.shimmer {
		border-radius: ${({ $cornerRadius }) => (typeof $cornerRadius === 'string' ? $cornerRadius : `${$cornerRadius}px`)};
		width: 100%;
		height: 100%;
		background-image: linear-gradient(-80deg, rgba(57, 57, 57, 0.1) 8%, rgba(0, 0, 0, 0.05) 18%, rgba(57, 57, 57, 0.1) 33%);
		background-repeat: no-repeat;
		background-position: 0 0;
		background-size: ${({ $heightInternal, $widthInternal }) =>
			`${
				$widthInternal ? `calc(${typeof $widthInternal === 'string' ? $widthInternal : `${$widthInternal}px`} * 10)` : '1000%'
			} ${typeof $heightInternal === 'string' ? $heightInternal : `${$heightInternal}px`}`};
		animation-duration: 2s;
		animation-fill-mode: forwards;
		animation-iteration-count: infinite;
		animation-name: ${animation};
		animation-timing-function: ease-in-out;
		display: flex;
	}
`;

export function Shimmer({ className, width, height, opacity = 1, cornerRadius = 12 }: Props): JSX.Element {
	return (
		<StyledShimmer
			className={className}
			$widthInternal={width}
			$heightInternal={height}
			$cornerRadius={cornerRadius}
			$opacityInternal={opacity}
		>
			<div className='shimmer' />
		</StyledShimmer>
	);
}
